'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiCurrencyMessages = function () {
  function MultiCurrencyMessages(el) {
    (0, _classCallCheck3.default)(this, MultiCurrencyMessages);

    var context = { context: el };

    this.els = {
      el: el,
      countryMessages: (0, _functional.getElements)('.prd-Delivery_Message', context),
      saveMessageOriginal: (0, _functional.getElement)('[data-save-message-replace]'),
      deliveryMessageOriginal: (0, _functional.getElement)('[data-delivery-message-replace]')
    };

    this.checkCountryCodeIsSet();
  }

  (0, _createClass3.default)(MultiCurrencyMessages, [{
    key: 'checkCountryCodeIsSet',
    value: function checkCountryCodeIsSet() {
      var _this = this;

      var countryCodeIsSet = function countryCodeIsSet() {
        if (_jsCookie2.default.get('countryCode')) {
          _this.setMessages();
          clearInterval(checkCountryCode);
        }
      };

      var checkCountryCode = setInterval(countryCodeIsSet, 100);
    }
  }, {
    key: 'setMessages',
    value: function setMessages() {
      var _this2 = this;

      var countryCode = _jsCookie2.default.get('countryCode');
      this.els.countryMessages.forEach(function (message) {
        if (message.dataset.country.includes(countryCode)) {
          var saveMessage = (0, _functional.getElement)('[data-save-message]', {
            context: message
          });
          var deliveryMessage = (0, _functional.getElement)('[data-delivery-message]', {
            context: message
          });

          if (saveMessage && _this2.els.saveMessageOriginal) {
            _this2.els.saveMessageOriginal.innerHTML = saveMessage.innerHTML;
          }

          if (deliveryMessage && _this2.els.deliveryMessageOriginal) {
            _this2.els.deliveryMessageOriginal.innerHTML = deliveryMessage.innerHTML;
          }
        }
      });
    }
  }]);
  return MultiCurrencyMessages;
}();

exports.default = MultiCurrencyMessages;